<template>
  <div
    data-qa="welcome_bonus"
    class="d-flex flex-column bg-gray-40 rounded py-2 px-3"
  >
    <div class="d-flex align-center">
      <span class="ui-icon-gift ui-icon-fz-smaller special--text mr-1" />
      <span
        data-qa="welcome_bonus_welcome_bonus"
        class="text-subtitle-1 text--text"
      >
        {{ welcomeBonusAmount.toLocaleString() }}&nbsp;
      </span>
      <span
        data-qa="welcome_bonus_welcome_bonus_text"
        class="text-body-1 text--text"
      >
        {{ t(welcomeBonusAmountText, options) }}
      </span>
    </div>
    <span
      class="text-caption text-secondary--text text-pre-line"
    >{{ t('При оформлении карты лояльности в клинике.\nПотратить можно сразу.', options) }}</span>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import I18NextVue from 'i18next'
import declensionByNum from 'src/utils/declensionByNum'

const { t, language } = I18NextVue
const options = { ns: language }

const props = defineProps<{
  welcomeBonusAmount: number
}>()

const welcomeBonusAmountText = computed(() => declensionByNum(props.welcomeBonusAmount, [
  'приветственный бонус',
  'приветственных бонуса',
  'приветственных бонусов',
]))
</script>
